import { RowSiteDto } from "@/dtos";
import { Site } from "@/entities";

export const formatRowSite = (sites: Site[]): RowSiteDto[] => {
    return sites.map(x => {
        const row: RowSiteDto = {
            ...x,
            responsable: x.details.responsable,
            city: x.details.city,
            plan_label: x.plan.name,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}